module.exports = __webpack_public_path__ + "b33365886c71b9469fd5244626371331.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.html
// module id = 2163
// module chunks = 0